import type { PhysicalCargoSourceRow } from '../../types/physicalCargoSource';
import { filterSelectablePhysicalSources, physicalSourceToLoadingPoint } from './physicalSourceLoadingPoint';

export type SuccessorWarehousePrefillResult =
  | { kind: 'no_warehouse_context' }
  | { kind: 'matched'; loadingPatch: ReturnType<typeof physicalSourceToLoadingPoint> }
  | { kind: 'missing'; warehouseId: number; message: string };

export function resolveSuccessorWarehousePrefill(params: {
  applicationId: number;
  warehouseId?: number | null;
  sources: PhysicalCargoSourceRow[];
}): SuccessorWarehousePrefillResult {
  const whId = params.warehouseId != null ? Number(params.warehouseId) : NaN;
  if (!Number.isFinite(whId) || whId <= 0) {
    return { kind: 'no_warehouse_context' };
  }
  const selectable = filterSelectablePhysicalSources(params.sources);
  const match = selectable.find((s) => s.sourceType === 'warehouse' && s.sourceId === whId);
  if (!match) {
    return {
      kind: 'missing',
      warehouseId: whId,
      message:
        'Ожидаемый остаток на складе больше недоступен по данным CP-059. Выберите другой физический источник.'
    };
  }
  return {
    kind: 'matched',
    loadingPatch: physicalSourceToLoadingPoint(match, params.applicationId)
  };
}
